export class FinanceInvoiceListDialogModel {
    constructor(
        public debitNote: any
    ) {}
}